import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";
import { useQueryErrorToast } from "@shared/toasts/useQueryErrorToast";

import { PageContainer } from "../shared/components/PageContainer";

import { useCurrentWorkspaceFeatures } from "./api/helpers";
import { SubscriptionSection } from "./components/SubscriptionSection/SubscriptionSection";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";

// Deliberately not wrapped in `ExpiredWrapper`: this is the page the wrapper's own "Renew" button navigates to,
// and the control that actually starts a renewal only renders once the subscription has expired. Blurring it left
// an expired customer looping between two copies of the same unusable card. Access stays gated per control —
// `can("cancel", "Workspace")` is kept on expiry on purpose (see PermissionService).
function WorkspaceSubscriptionPage() {
    const { t } = useTranslation(["pages"]);
    const { workspace, canViewSubscription } = useWorkspacePageAccess();
    const features = useCurrentWorkspaceFeatures();
    const { data: workspaceFeatures = [], isLoading: isWorkspaceFeaturesLoading } = features;
    useQueryErrorToast(features);

    const subscription = workspace?.subscription;

    return (
        <PageContainer fullWidth={false}>
            {canViewSubscription && subscription ? (
                <SubscriptionSection
                    subscription={subscription}
                    features={workspaceFeatures}
                    isLoading={isWorkspaceFeaturesLoading}
                />
            ) : (
                <CustomAlert severity="info" title={t("pages:workspacePage.restricted.subscription.title")}>
                    {t("pages:workspacePage.restricted.subscription.description")}
                </CustomAlert>
            )}
        </PageContainer>
    );
}

export default withMetaDescription(WorkspaceSubscriptionPage, {
    title: i18next.t("pages:workspacePage.pages.subscription.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.subscription.metaDescription"),
});
